module.exports = "/assets/data/caace5fdd1ead491d61114bc03ace780-L30.data.json";